<template>
    <div>
        <h2>{{$t('SHEETS')}}</h2>
        <hr/>
        <div>
            <heading-icon icon="user" :title="$t('CREATE_SHEET')" :pointerCursor="true" @click="navigateToCreateNewSheet"/>
        </div>
        <hr/>
        <div class="card shadow mb-4">
            <div class="card-header card-header-main">
                <h6 class="m-0 font-weight-bold text-primary">{{$t('SHEETS')}}</h6>
                <span>{{ $t('SHEETS_DESCRIPTION') }}</span>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table 
                        show-empty
                        :hover="true"
                        :bordered="true"
                        :items="patientSheets"
                        :fields="fields">
                        <template v-slot:cell(name)="row">
                            {{ row.value }}
                        </template>
                        <template v-slot:cell(createdOn)="row">
                            {{ formatDate(row.value) }}
                        </template>
                        <template v-slot:cell(updatedOn)="row">
                            {{ formatDate(row.value) }}
                        </template>
                        <template v-slot:cell(view)="row">
                            <router-link v-if="activeSheet.id == row.item.id" :to="'/common-sense'">{{$t('VIEW')}}</router-link >
                            <router-link v-else :to="'/common-sense?sheetId=' + row.item.id">{{$t('VIEW')}}</router-link >
                        </template>
                        <template v-slot:cell(activate)="row">
                            <a href="#"  v-if="activeSheet.id != row.item.id" @click="activateSheet($event, row.item.id)">{{$t('ACTIVATE')}}</a >
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    import HeadingIcon from '../misc/HeadingIcon.vue'
    export default {
        components: {
            HeadingIcon
        },
        data () {
            return {
                emptyCgaPatient: {
                    firstName: '',
                    lastName: ''
                },
            }
        },
        computed: {
            fields(){ 
                return [
                    { key: 'name', label: this.$t('NAME'), sortable: true },
                    { key: 'createdOn', label: this.$t('CREATED_ON'), sortable: true },
                    { key: 'updatedOn', label: this.$t('UPDATED_ON') },
                    { key: 'view', label: this.$t('VIEW') },
                    { key: 'activate', label: this.$t('ACTIVATE') }
                ]
            },
            cgaPatient() {
                return this.$store.getters.cgaPatient || this.emptyCgaPatient;
            },
            activeSheet() {
                return this.$store.getters.cgaPatientSheet;
            },
            patientSheets() {
                if (!this.$store.getters.cgaPatientSheets) {
                    return this.$store;
                }
                return this.$store.getters.cgaPatientSheets.map(sh => {
                    if (sh.isActive) {
                        sh._rowVariant = 'secondary';
                    }
                    else if (sh._rowVariant) {
                        delete sh._rowVariant;
                    }

                    return sh;
                });
            }
        },
        methods: {
            activateSheet: function(event, sheetId) {
                event.preventDefault();
                let self = this;
                this.$store.dispatch("activateSheet", sheetId)
                    .then(response => {

                    })
                    .catch(error => {

                    });
            },
            formatDate: function(dateString) {
                return moment(String(dateString)).format('DD/MM/YYYY');
            },
            navigateToCreateNewSheet() {
                this.$router.push({ path: "/sheets/create" });
            }
        },
        mounted: function () {

        }
    }
</script>
<style lang="scss" scoped>
    .card-header {
        background-color: white;
        h6, span {
            color: black !important;
        }
        span {
            font-style: italic;
            font-size: 0.9em;
        }
    }
</style>